(function () {
    'use strict';

    angular
        .module('app')
        .controller('SaveTagDialogCtrl', SaveTagDialogCtrl);

    SaveTagDialogCtrl.$inject = ['DialogInstance', 'linkedItems'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog prompting the user for confirmation they wish to save a tag.
     * This dialog should be utilised when the tag is used by one or more item which is from outside the tags usage area.
     * 
     */
    function SaveTagDialogCtrl(DialogInstance, linkedItems) {
        /* jshint validthis:true */
        var vm = this;
        vm.linkedItems = linkedItems;
        vm.ok = ok;
        vm.cancel = cancel;

        function ok() {
            DialogInstance.ok();
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();
